import axios from "axios";
import { API } from "./api";

const axiosInstance = axios.create({
	baseURL: API.flaggaAdminUrl,
});

export default axiosInstance;
